import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../css/Industry.css";

const industries = [
  {
    title: "EdTech",
    desc: "With the increasing demand for online learning, students and educators expect timely and effective support when they encounter technical issues. We will help you develop a trusted brand in Education industry.",
    img: "/industry/65338efd7a9bc84b73f26433_Learning-cuate.svg",
  },
  {
    title: "NBFC & BFSI",
    desc: "We offer personalized support on financial products, and resolve account setup, billing and other financial concerns. Establish yourselves as a trusted partner and drive business growth.",
    img: "/industry/65338efd7a9bc84b73f26434_Revenue-bro.svg",
  },
  {
    title: "E-Commerce & Retail",
    desc: "Customers expect prompt and efficient assistance when they encounter issues with products, orders, or shipping. Our services enhance the brand reputation of your Retail or E-Commerce business.",
    img: "/industry/65338efd7a9bc84b73f26435_In no time-pana.svg",
  },
  {
    title: "Government & Public Services",
    desc: "Many Government and Non-Government organizations utilize our services to support their backend operations, technical assistance and data support services from last 5 years.",
    img: "/industry/65338efd7a9bc84b73f26437_Back to back-pana.svg",
  },
  {
    title: "Automotive",
    desc: "Get the support you need to achieve your business goals with our comprehensive automation solutions.",
    img: "/industry/65338efd7a9bc84b73f26438_Robotics-pana.svg",
  },
  {
    title: "Others",
    desc: "Nimbus BPO is fresh and full of synergy. We are open to new and unutilized industries. We aim to help and support your business with our best abilities.",
    img: "/industry/65338efd7a9bc84b73f26436_Globalization-pana.svg",
  },
];

const Industry = () => {
  return (
    <section className="industry-section">
      <Container>
        {/* Heading */}
        <div className="text-center mb-5">
          <small className="text-primary fw-semibold">Our Expertise</small>
          <h2 className="fw-bold mt-2">Industries We Served</h2>
          <p className="text-muted mt-2">
            Trusted by over 22+ prestigious corporations in India for backend
            office work and customer support.
          </p>
        </div>

        {/* Industry Cards */}
        <Row>
          {industries.map((item, index) => (
            <Col lg={3} md={4} sm={6} className="mb-4" key={index}>
              <Card className="industry-card h-100">
                <Card.Img
                  variant="top"
                  src={item.img}
                  className="industry-img"
                />
                <Card.Body>
                  <Card.Title>{item.title}</Card.Title>
                  <Card.Text>{item.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Buttons */}
        <div className="text-center mt-4">
          <Button variant="outline-secondary" className="me-3">
            Read FAQs
          </Button>
          <Button variant="primary">Contact Us</Button>
        </div>
      </Container>
    </section>
  );
};

export default Industry;
